import React, { ReactElement } from "react";

interface Props {
  title: string
  handleSubmit: () => void
  children: ReactElement
}

const LoginFormStructure: React.FC<Props> = ({ handleSubmit, title, children }) => {
  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    handleSubmit()
  }

  return (
    <form onSubmit={submit} className="w-full h-fit flex flex-col gap-3">
      <h2 className="text-center mb-3">{title}</h2>
      {children}
    </form>
  )
}

export default LoginFormStructure;